import React from "react";
import { useLocation } from "react-router-dom";
import ConversationDetailPage from "./ConversationDetailPage";

/**
 * Wrapper component for ConversationDetailPage that handles initial data from navigation state
 * This allows the page to reuse data from the conversations list without making additional API calls
 */
const ConversationDetailWrapper = () => {
  const location = useLocation();
  const initialConversation = location.state?.conversation;

  return <ConversationDetailPage initialConversation={initialConversation} />;
};

export default ConversationDetailWrapper;
